import * as React from "react";
import { Grid, FormControl, FormLabel, Typography } from "@mui/material";
import { OptionListItem } from "modules/common/components/forms";
import { ExternalLink } from "modules/common/components/misc/externalLink";

export interface Bill11OptionsContainerProps {
    isUpdatingAddressToBeOutsideOfAlberta?: boolean;
    onSelectionChange: (value: boolean) => void;
}

export function Bill11OptionsContainer({
    isUpdatingAddressToBeOutsideOfAlberta,
    onSelectionChange
}: Bill11OptionsContainerProps) {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3} />
                <Grid item xs={12} md={9}>
                    <FormControl fullWidth>
                        <FormLabel className="control-label">Are you moving out of Alberta?</FormLabel>
                        <div className="options-container">
                            <OptionListItem
                                option={{ key: "Yes", content: "Yes", value: true, visible: true }}
                                key="yes"
                                selected={isUpdatingAddressToBeOutsideOfAlberta === true}
                                onClick={() => onSelectionChange(true)}
                                className={"yes-no-option"}
                            />
                            <OptionListItem
                                option={{ key: "No", content: "No", value: false, visible: true }}
                                key="no"
                                selected={isUpdatingAddressToBeOutsideOfAlberta === false}
                                onClick={() => onSelectionChange(false)}
                                className={"yes-no-option"}
                            />
                        </div>
                    </FormControl>
                </Grid>
            </Grid>
            {isUpdatingAddressToBeOutsideOfAlberta === true && (
                <Grid container>
                    <Grid item xs={12} md={3} />
                    <Grid item xs={12} md={8}>
                        <div className="proof-of-address-section">
                            <div className="exclamation">!</div>
                            <div>
                                <Typography variant="h6">
                                    Proof of address is required when moving out of Alberta.
                                </Typography>
                                <div className="message">
                                    Please{" "}
                                    <ExternalLink
                                        to="https://www.myretireeplan.ca/wp-content/uploads/2026/03/ASEBP-186-MyRetiree-Plan-Change-Application-Form.pdf"
                                        color="primary">
                                        download and read the change request form
                                    </ExternalLink>{" "}
                                    carefully to ensure you submit the proper documentation.
                                </div>
                                <div className="message">
                                    Completed form and proof of address can be sent to ASEBP via email to
                                    benefits@asebp.ca, fax to 780-438-5304, or by mail to Suite 301, 6104-104 Street NW
                                    Edmonton, AB T6H 2K7.
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )}
        </>
    );
}
